import React from "react";
import { toast, } from "react-toastify"
import { NavLink } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import Contacts from "@material-ui/icons/Contacts";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import { fetchData } from '../../utils/handleApi'
import { Switch, FormControlLabel, FormGroup, } from '@material-ui/core';

const GreenSwitch = withStyles({
  switchBase: {
    color: "#04ab23",
    '&$checked': {
      color: "#04ab23",
      '& + $bar': {
        backgroundColor: "#04ab23",
      },
    },
  },
  checked: {},
  bar: {},
})(Switch);

var initialEmail = "";
var fieldsModified = false;
class EditEmailForm extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      email_address: "",
      email_addressState: "",
      password: "",
      passwordState: "",
      is_notification: false,
  
      
      required: "",
      requiredState: "",
      typeEmail: "",
      typeEmailState: "",
      number: "",
      numberState: "",
      url: "",
      urlState: "",
      equalTo: "",
      whichEqualTo: "",
      equalToState: "",
      
      minLength: "",
      minLengthState: "",
      maxLength: "",
      maxLengthState: "",
      range: "",
      rangeState: "",
      minValue: "",
      minValueState: "",
      maxValue: "",
      maxValueState: "",
      
      isFormSubmitting: false,
    }
    this.oldState = this.state;
  }

  validateError = () => {
    const { password } = this.state;
    if (password.length < 5) {
      return true;
    }
  }

  componentDidMount(){
    let { vendorId, credentialId } = this.props.match.params;
    fetchData('vendor/allCredentials', 'post', {
      vendor_id: vendorId,
    })
    .then(data => {
      if(data.err){
        return toast.error('Some error happened!')
      }
      let currentEmail = data.filter((email) => email._id === credentialId)[0]
      this.setState({
        email_address: currentEmail.email_address,
        email_addressState: 'success',
        password: currentEmail.password,
        passwordState: 'success',
        is_notification: currentEmail.is_notification === "true" ? true : false,
      })
      initialEmail = currentEmail.email_address;
      this.oldState = this.state;
    })
  }

  
  verifyEmail(value) {
    let emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }
  
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  
  compare(string1, string2) {
    if (string1 === string2) {
      return true;
    }
    return false;
  }
  
  verifyNumber(value) {
    let numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  }
  
  verifyUrl(value) {
    try {
      new URL(value);
      return true;
    } catch (_) {
      return false;
    }
  }

  change(event, stateName, type, maxValue) {
    fieldsModified = true;
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else if(this.verifyLength(event.target.value, 0)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 0)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      default:
        break;
    }
  }

  handleFormSubmit = (data) => {
    if(data.err){
      if(data.err.data.message){
        return toast.error('Email address already exists!', {
          onClose: () => this.setState({ isFormSubmitting: false })
        })
      }
    else { 
      toast.error('Some error happened!', {
        onClose: () => this.setState({ isFormSubmitting: false })
      })}
    }
    toast.success('Credentials Updated Successfully!', {
      onClose: () => {
        this.setState({ isFormSubmitting: false })
        this.props.history.goBack()
      }
    })
  }

  editCredential = () => {
    let isValid = true;
    const { email_addressState, email_address, password, is_notification } = this.state; 
    if (this.validateError()) {
      return toast.error("Password must be at least 5 characters long!")
    }
    if (email_address.trim() === "" || email_addressState === "error") {
      this.setState({ email_addressState: "error" });
      isValid = false
    }
    if (password.trim() === "" || password.length < 5) {
      this.setState({ passwordState: "error" });
      isValid = false
    }
    
    if(isValid){
      this.setState({ isFormSubmitting: true })
      let { vendorId, credentialId } = this.props.match.params;
      let credentialBody = {
        email_address,
        password, 
        is_notification,
        vendor_id: vendorId,
        credential_id: credentialId,
      };
      if(this.oldState.email_address !== this.state.email_address && this.oldState.password === this.state.password && this.oldState.is_notification === this.state.is_notification) {
        //Only email is changed
        credentialBody = {
          ...credentialBody,
          onlyEmailChanging : 1, onlyPasswordChanging : 0, onlyNotificationChanging: 0
        }
        return fetchData('vendor/updateCredentials', 'post', credentialBody)
        .then(data => this.handleFormSubmit(data))
      }
      else if(this.oldState.password !== this.state.password && this.oldState.email_address === this.state.email_address && this.oldState.is_notification === this.state.is_notification){
        //Only password is changed
        credentialBody = {
          ...credentialBody,
          onlyEmailChanging : 0, onlyPasswordChanging : 1, onlyNotificationChanging: 0
        }
        return fetchData('vendor/updateCredentials', 'post', credentialBody)
        .then(data => this.handleFormSubmit(data))
      }
      else if(this.oldState.is_notification !== this.state.is_notification && this.oldState.email_address === this.state.email_address && this.oldState.password === this.state.password){
        //Only notification is changed
        credentialBody = {
          ...credentialBody,
          onlyEmailChanging : 0, onlyPasswordChanging : 0, onlyNotificationChanging: 1
        }
        return fetchData('vendor/updateCredentials', 'post', credentialBody)
        .then(data => this.handleFormSubmit(data))
      }
      else if(this.oldState.email_address !== this.state.email_address && this.oldState.password !== this.state.password && this.oldState.is_notification === this.state.is_notification) {
        //Email & Password are changed
        credentialBody = {
          ...credentialBody,
          onlyEmailChanging : 1, onlyPasswordChanging : 1, onlyNotificationChanging: 0
        }
        return fetchData('vendor/updateCredentials', 'post', credentialBody)
        .then(data => this.handleFormSubmit(data))
      }
      else if(this.oldState.email_address !== this.state.email_address && this.oldState.password === this.state.password && this.oldState.is_notification !== this.state.is_notification) {
        //Email & Notification are changed
        credentialBody = {
          ...credentialBody,
          onlyEmailChanging : 1, onlyPasswordChanging : 0, onlyNotificationChanging: 1
        }
        return fetchData('vendor/updateCredentials', 'post', credentialBody)
        .then(data => this.handleFormSubmit(data))
      }
      else if(this.oldState.email_address === this.state.email_address && this.oldState.password !== this.state.password && this.oldState.is_notification !== this.state.is_notification) {
        //Password & Notification are changed
        credentialBody = {
          ...credentialBody,
          onlyEmailChanging : 0, onlyPasswordChanging : 1, onlyNotificationChanging: 1
        }
        return fetchData('vendor/updateCredentials', 'post', credentialBody)
        .then(data => this.handleFormSubmit(data))
      }
      else if(this.oldState.email_address !== this.state.email_address && this.oldState.password !== this.state.password && this.oldState.is_notification !== this.state.is_notification) {
        //All 3 keys are changed
        credentialBody = {
          ...credentialBody,
          onlyEmailChanging : 1, onlyPasswordChanging : 1, onlyNotificationChanging: 1
        }
        return fetchData('vendor/updateCredentials', 'post', credentialBody)
        .then(data => this.handleFormSubmit(data))
      }
    }
  }

  checkDirty = () => {
    if(fieldsModified){
      return false
    }
    return true;
  }

  render() {
    const { email_addressState, email_address, passwordState, password, is_notification } = this.state;
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color="success">
                <Contacts />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Update Vendor Credentials</h4>
              <NavLink to={`/admin/vendor/emails/${this.props.match.params.vendorId}`}>
                <Button
                style={{
                  float: 'right',
                  backgroundColor: "rgb(4, 171, 35)" 
                }}
                >Back
                </Button>
              </NavLink>
            </CardHeader>
            <CardBody>
              <form>
                <CustomInput
                  success={email_addressState === "success"}
                  error={email_addressState === "error"}
                  labelText="Email Address *"
                  id="email_address"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "email_address", "email", 0),
                    type: "email",
                    value: email_address
                  }}
                />
                <CustomInput
                  success={passwordState === "success"}
                  error={passwordState === "error"}
                  labelText="Password *"
                  id="password"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "password", "password", 0),
                    type: "password",
                    value: password,
                  }}
                />
                 <FormGroup row>
                  <FormControlLabel
                    control={
                      <GreenSwitch
                        checked={is_notification}
                        value={is_notification.toString()}
                        onChange={() => {
                          fieldsModified = true;
                          this.setState({ is_notification: !is_notification})
                        }}
                        id="is_notifcation"
                        name="is_notifcation"                      
                      />
                    }
                    label="Receive Email Notifications?"
                  />
                </FormGroup>
                <div className={classes.center}>
                  <Button
                    disabled={
                      this.state.isFormSubmitting || 
                      (this.oldState.is_notification === this.state.is_notification &&
                      initialEmail === this.state.email_address && 
                      this.oldState.password === this.state.password) || 
                      this.checkDirty()
                    }
                    style ={{backgroundColor: "rgb(4, 171, 35)"}} 
                    onClick={this.editCredential}>
                      Update Credentials
                  </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(validationFormsStyle)(EditEmailForm);